const navObj = [
  "Home", "Resume", "Projects", "Contact"
]

export default navObj;